var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-type-02 fixed-bottom-area",
      attrs: { id: "fixed-bottom-nav-div" },
    },
    [
      _c("div", { staticClass: "save-label" }, [
        _vm._v("\n    応募フォームで編集した内容は途中保存可能です。\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "save-balloon-login" }),
      _vm._v(" "),
      _c("div", { staticClass: "-block w49 save-button" }, [
        _c("a", { staticClass: "link-button review" }, [
          _c("img", {
            staticClass: "heart",
            attrs: { src: _vm.userCommonImageUrlForSp + "/icon_heart_sp.png" },
          }),
          _vm._v("気になる\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "-block w49" }, [
        _vm.isSimple && !_vm.isOriginalEntryForm
          ? _c(
              "a",
              {
                staticClass: "link-button -type02 -pr",
                attrs: { "data-test": "simple" },
              },
              [
                _c("img", {
                  attrs: { src: _vm.userOfferImageUrlForSp + "/icon_pr.png" },
                }),
                _vm._v("\n      シンプル応募\n    "),
              ]
            )
          : _c(
              "a",
              {
                staticClass: "link-button -type02",
                attrs: { "data-test": "entry" },
              },
              [_vm._v("\n      応募する\n    ")]
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }